export let opt_chart = {
  companyInfoOption: {
    legend: {
      orient: 'horizontal',
      top: 'bottom',
      textStyle: {
        "fontSize": 9
      }
    },
    tooltip: {
      trigger: 'item'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '5%',
      containLabel: true
    },
    series: [
      {
      name: '',
      type: 'pie',
      radius: '50%',
      label: {
        normal: {
          show: true,
          formatter: '{b}: {d}%', //自定义显示格式(b:name, c:value, d:百分比)
          textStyle: {
            "fontSize": 12
          },
        }
      },
      data: [],

    }]
  },
  parkInfoOption: {
    title: {
      text: '55%',
      subtext: '',
      left: 'center',
      top: 'center'
    },

    series: [{
      name: '',
      type: 'pie',
      radius: ['60%', '70%'],
      avoidLabelOverlap: true,

      emphasis: {
        label: {
          show: false,
          fontSize: 20,
          fontWeight: 'bold'
        }
      },
      labelLine: {
        show: true
      },
      data: [{
          value: 700,
          name: '未用车位'
        },
        {
          value: 300,
          name: '已用停车位'
        },

      ]
    }]
  },
  goRoomRankOption: {
    legend: {},
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: "value",
      data: []
    },
    yAxis: {
      data: []
    },
    series: [
    ]
  },
  goRoomServeOption: {
    title: {
      text: ''
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      // boundaryGap: true,
      data: []
    },
    yAxis: {
      min: 0,
      max: 180
    },
    series: [
      // {
      //   name: 'Email',
      //   type: 'line',

      //   data: [60, 66,62,63,70,89,90,65,61,63,64,68,77,72,82,81,75,83,65,71,67,68,76,77,79,80,81,82,83,84,85,86,87,88,65]
      // },

    ]
  },
  orderInfoOption: {

    tooltip: {
      trigger: 'axis'
    },
    legend: {

    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },

    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ["04", '05', '06', '07', '08', '09', '10', "11", "12", "01", "02", "03"]
    },
    yAxis: {
      type: 'value'
    },
    series: [{
        name: '工单总量',
        type: 'line',

        data: [7021, 6477, 6628, , 6588, 6842, 6895, 6943, 6639, 6786, 6882, 6104, 6754]
      },
      {
        name: '已完成',
        type: 'line',

        data: [7021, 6282, 6495, 6522, 6842, 6895, 6943, 6506, 6514, 6537, 5554, 5808]
      },

    ]
  },
  shopAccountInfoOption: {
    title: {
      text: ''
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      // boundaryGap: true,
      data: []
    },
    yAxis: {
      min: 0,
      max: 100
    },
    series: [
      // {
      //   name: 'Email',
      //   type: 'line',

      //   data: [60, 66,62,63,70,89,90,65,61,63,64,68,77,72,82,81,75,83,65,71,67,68,76,77,79,80,81,82,83,84,85,86,87,88,65]
      // },

    ]
  },
 

}
